import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './AccessForm.css';
import axios from 'axios';
import axiosInstance from '../../../Services/AxiosAPICaller';
import Admin_sended_Form_Template from '../../../Ressources/MailsTemplates/Admin_sendForm_Access_Template';

const AccessForm: React.FC = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const navigate = useNavigate();

    const handleCheckData = async (event:React.FormEvent) =>
        {
            event.preventDefault();

            //we check if the form is valid
            const form = document.getElementById('AccessForm') as HTMLFormElement
            const inputs = form.querySelectorAll('input');
            let isValid = true;

            inputs.forEach(input => {
                if (input.id !== 'ReferentPhone' && input.id !== 'ReferentMail') {
                    if (!input.value || input.value.trim() === '') {
                        input.style.borderWidth = '2px';
                        input.style.borderColor = 'red';
                        isValid = false;
                        const errorMessage = document.getElementById('InvalidFormMessage') as HTMLParagraphElement;
                        errorMessage.textContent = 'Les champs entourés en rouge sont obligatoires, merci de les renseigner.';
                    } else {
                        input.style.borderColor = 'transparent';
                    }
                }
            });

            if (isValid)
            {
                //Sending mail to the admins

                const BaseRedirectUrl = process.env.REACT_APP_MAIL_REDIRECT_URL;
                if (!BaseRedirectUrl){
                    console.log('Mail Base Redirect Url key is missing !');
                    return;
                }
                // we set the html template for the mail
                const htmlTemplate = await ReplaceDynamicValue(Admin_sended_Form_Template, form);

                const brevoApiKey = process.env.REACT_APP_BREVO_API_KEY;

                if (!brevoApiKey) {
                    console.log('BREVO API key is missing');
                    return;
                }

                // we need another axios instance to use Brevo API
                const BrevoAxiosOptions = (email: string) => ({
                    method: 'POST',
                    url: 'https://api.brevo.com/v3/smtp/email',
                    headers: {
                        accept: 'application/json',
                        'content-type': 'application/json',
                        'api-key': brevoApiKey
                    },
                    data: {
                        sender:  {name:"Paluel-OnlyContact",email:"paluel@onlycontact.fr"},
                        to: [{email, name: email}],
                        htmlContent: htmlTemplate,
                        subject: "Quelqu'un souhaite accéder a l'application Paluel-OnlyContact !",
                        replyTo: {email:"paluel@onlycontact.fr",name:"Paluel-OnlyContact"}
                    }
                });

                //get the mails of EDF_Admin users
                // In Local development, for debug, use the Admin role instead of EDF_Admin

                axiosInstance.get('/users?populate[role][field][0]=name&&filters[role][name][$eq]=EDF_Admin')
                .then(response => {

                    const MailToSend = response.data.map((user: any) => user.email);

                    MailToSend.forEach((email: string) => {
                        axios.request(BrevoAxiosOptions(email))
                             .then()
                             .catch(err => console.error(err));
                    });
                })
                .catch(err => console.error(err));

                //Navigate to the validated action page
                navigate('/AccessFormSended');
            }
        }

  return (
    <div className="form-container">

        <p className='HeaderMsg'>Ce mail n’est pas autorisé à accéder à ces informations, veuillez remplir ce formulaire pour faire une demande d’autorisation</p>
        
        <form id='AccessForm'>
            <div className='FormSection'>
                <label htmlFor="LastName" className="LabelAccessForm">Nom</label>
                <input
                    type="text"
                    id="LastName"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                />
            </div>

            <div className='FormSection'>
                <label htmlFor="FirstName" className="LabelAccessForm">Prénom</label>
                <input
                    type="text"
                    id="FirstName"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                />
            </div>
            <div className='FormSection'>
                <label htmlFor="Mail" className="LabelAccessForm">Mail</label>
                <input
                    type="email"
                    id="Mail"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                /> 
            </div>
            <div className='FormSection'>
                <label htmlFor="Phone" className="LabelAccessForm">Téléphone</label>
                <input
                    type="tel"
                    id="Phone"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                />
            </div>
            <div className='FormSection'>
                <label htmlFor="Enterprise" className="LabelAccessForm">Entreprise</label>
                <input
                    type="Text"
                    id="Enterprise"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                /> 
            </div>

            <p className='HeaderReferent'>Référent EDF ou manager</p>

            <div className='FormSection'>
                <label htmlFor="ReferentName" className="LabelAccessForm">Nom</label>
                <input
                    type="text"
                    id="ReferentName"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                />
            </div>

            <div className='FormSection'>
                <label htmlFor="ReferentMail" className="LabelAccessForm">Mail</label>
                <input
                    type="email"
                    id="ReferentMail"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                />
            </div>

            <div className='FormSection'>
                <label htmlFor="ReferentPhone" className="LabelAccessForm">Téléphone</label>
                <input
                    type="tel"
                    id="ReferentPhone"
                    className="AccessFormInput"
                    onInvalid={(e) => e.preventDefault()} // Prevent default invalid popup
                />
            </div>

            <button type="submit" className="form-button" onClick={(e) => handleCheckData(e)}>Valider</button>
            <p id='InvalidFormMessage' className="error-message"></p>
        </form>
    </div>
  );
};

export default AccessForm;

async function ReplaceDynamicValue(htmlTemplate: string, form: HTMLFormElement): Promise<string> {
    const dynamicValues = {
        '{{LastName}}': form.LastName.value,
        '{{FirstName}}': form.FirstName.value,
        '{{Mail}}': form.Mail.value,
        '{{Phone}}': form.Phone.value,
        '{{Company}}': form.Enterprise.value,
        '{{ReferentName}}': form.ReferentName.value,
        '{{ReferentMail}}': form.ReferentMail.value,
        '{{ReferentPhone}}': form.ReferentPhone.value,
        '{{MailRedirectUrl}}': process.env.REACT_APP_MAIL_REDIRECT_URL || '',
    };

    let modifiedHtml = htmlTemplate;

    for (const [key, value] of Object.entries(dynamicValues)) {
        const regex = new RegExp(key, 'g');
        modifiedHtml = modifiedHtml.replace(regex, value);
    }

    return modifiedHtml;
}

